import { createSlice } from "@reduxjs/toolkit";
import axios from "../../services/authService";
import { API_ENDPOINTS } from '../../config/apiConfig';

export const editDevicesSlice = createSlice({
    name: "editDevices",
    initialState: {
        loading: false,
        response: {},
        error: null
    },
    reducers: {
        reset: (state) => {
            state.loading = false;
            state.response = {};
            state.error = null;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResponse: (state, action) => {
            state.response = action.payload;
            state.loading = false;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        }
    }
});

export const {
    reset,
    setLoading,
    setResponse,
    setError
} = editDevicesSlice.actions;

/**
 * Update an existing device in the database
 * @param {number} deviceId - The database ID of the device
 * @param {Object} deviceData - Updated device data (only include changed fields)
 */
export const updateDeviceAsync = (deviceId, deviceData) => async (dispatch) => {
    dispatch(reset());
    dispatch(setLoading(true));

    try {
        const url = `${API_ENDPOINTS.UPDATE_DEVICE}?id=${deviceId}`;
        const response = await axios.put(url, deviceData);

        dispatch(setResponse({
            message: "Device updated successfully",
            data: response.data
        }));

        return { success: true, data: response.data };

    } catch (err) {
        const errorMessage = err.response?.data?.message || err.message || "Failed to update device";
        console.error("Error updating device:", errorMessage);
        dispatch(setError(errorMessage));
        return { success: false, error: errorMessage };
    }
};

// Selectors
export const selectUpdateDeviceLoading = (state) => state.editDevices.loading;
export const selectUpdateDeviceResponse = (state) => state.editDevices.response;
export const selectUpdateDeviceError = (state) => state.editDevices.error;

export default editDevicesSlice.reducer;
